import React from "react";
import { useInView } from "react-intersection-observer";
import "./HiringToolsSection.css";

const toolCards = [
  {
    title: "ATS CV",
    videoSrc: "https://cdn-icons-mp4.flaticon.com/512/15578/15578457.mp4",
    fallbackImg: "https://cdn-icons-png.flaticon.com/512/15578/15578457.png",
  },
  {
    title: "Skill Test",
    videoSrc: "https://cdn-icons-mp4.flaticon.com/512/16664/16664316.mp4",
    fallbackImg: "https://cdn-icons-png.flaticon.com/512/16664/16664316.png",
  },
  {
    title: "Certification",
    videoSrc: "https://cdn-icons-mp4.flaticon.com/512/17490/17490066.mp4",
    fallbackImg: "https://cdn-icons-png.flaticon.com/512/17490/17490066.png",
  },
  {
    title: "Mock Interview",
    videoSrc: "https://cdn-icons-mp4.flaticon.com/512/17556/17556380.mp4",
    fallbackImg: "https://cdn-icons-png.flaticon.com/512/17556/17556380.png",
  },
  {
    title: "1-1 Mentorship",
    videoSrc: "https://cdn-icons-mp4.flaticon.com/512/19026/19026301.mp4",
    fallbackImg: "https://cdn-icons-png.flaticon.com/512/19026/19026301.png",
  },
  {
    title: "Career Insights",
    videoSrc: "https://cdn-icons-mp4.flaticon.com/512/19016/19016785.mp4",
    fallbackImg: "https://cdn-icons-png.flaticon.com/512/19016/19016785.png",
  },
];

export default function HiringToolsSection({ theme = "light" }) {
  const { ref, inView } = useInView({ threshold: 0.15, triggerOnce: true });

  return (
    <section
      ref={ref}
      className={`hiring-tools-section theme-${theme} ${
        inView ? "in-view" : ""
      }`}
    >
      <div className="tools-title-wrapper">
        <h2 className="tools-title">EVERYTHING YOU NEED TO GET HIRED</h2>
      </div>
      <div className="tools-grid">
        {toolCards.map((card, index) => (
          <div key={index} className={`tool-card card-${index + 1}`}>
            <div className="card-icon">
              <video
                width="80"
                height="80"
                preload="none"
                style={{
                  background: `transparent url('${card.fallbackImg}') 50% 50% / contain no-repeat`,
                }}
                autoPlay
                loop
                muted
                playsInline
              >
                <source src={card.videoSrc} type="video/mp4" />
              </video>
            </div>
            <h3 className="card-title">{card.title}</h3>
            <p className="card-description">{card.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
